export type DashboardKpiCardsState = "loading" | "empty" | "ready" | "error";

/** Derive card UI state — ready/empty wins over poll timeout so cards never vanish mid-session. */
export function deriveCardState(
  timedOut: boolean,
  status: string | undefined,
  kpiCards: unknown,
): DashboardKpiCardsState {
  if (kpiCards) return "ready";
  if (kpiCards === null) return "empty";
  if (status === "FAILED") return "error";
  if (timedOut) return "error";
  return "loading";
}
